export const selectNotes = (state) => state.notes.notes;
export const selectIsLoading = (state) => state.notes.isLoading;
export const selectError = (state) => state.notes.error;
